<script setup lang="ts">
import { computed } from 'vue'

import BetaCanvasFitFrame from '@/components/beta-editor/canvas/molecules/BetaCanvasFitFrame.vue'
import { BETA_EDITOR_CANVAS_WIDTHS, type BetaEditorPreviewDevice } from '@/utils/editor-beta-preview'

const MOBILE_VIEWPORT_CHROME_PADDING = 36
const TABLET_VIEWPORT_CHROME_PADDING = 28

const props = defineProps<{
    device: BetaEditorPreviewDevice
}>()

const isMobilePreview = computed(() => props.device === 'mobile')
const isFramedPreview = computed(() => props.device === 'mobile' || props.device === 'tablet')
const canvasLogicalWidth = computed(() => BETA_EDITOR_CANVAS_WIDTHS[props.device])
const viewportLogicalWidth = computed(() => (
    isMobilePreview.value
        ? BETA_EDITOR_CANVAS_WIDTHS.mobile + MOBILE_VIEWPORT_CHROME_PADDING
        : props.device === 'tablet'
            ? BETA_EDITOR_CANVAS_WIDTHS.tablet + TABLET_VIEWPORT_CHROME_PADDING
            : BETA_EDITOR_CANVAS_WIDTHS.desktop
))
</script>

<template>
    <beta-canvas-fit-frame :logical-width="viewportLogicalWidth">
        <div :class="['beta-editor-viewport', isFramedPreview && 'is-framed', isMobilePreview && 'is-mobile']">
            <div
                class="beta-editor-viewport__canvas"
                :data-preview-device="props.device"
                :style="{ width: `${canvasLogicalWidth}px` }"
            >
                <slot />
            </div>
        </div>
    </beta-canvas-fit-frame>
</template>

<style scoped>
.beta-editor-viewport {
    @apply flex justify-center overflow-visible transition-all duration-200;
    width: 100%;
}

.beta-editor-viewport.is-framed {
    @apply rounded-[32px] p-[14px];
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(243, 246, 252, 0.92) 100%);
    box-shadow: 0 30px 70px rgba(15, 23, 42, 0.08), inset 0 0 0 1px rgba(214, 223, 236, 0.85);
}

.beta-editor-viewport.is-mobile {
    @apply p-[18px];
}

.beta-editor-viewport__canvas {
    @apply relative min-w-0 overflow-visible transition-all duration-200;
    max-width: 100%;
    container-type: inline-size;
    container-name: editor-beta-canvas;
}
</style>
